import { __assign, __rest } from "tslib";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { TestId } from "./TestId";
export var ContainerTreeList = function (_a) {
    var children = _a.children, className = _a.className, handleOnBlur = _a.handleOnBlur, props = __rest(_a, ["children", "className", "handleOnBlur"]);
    var onBlurHandler = function (event) {
        handleOnBlur(event);
    };
    return (jsx("ul", __assign({ css: {
            position: "relative",
            listStyleType: "none",
            margin: 0,
            padding: 0,
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto"
        }, className: className, role: "tree", "data-testid": TestId.UL_ELEMENT, onBlur: onBlurHandler }, props), children));
};
//# sourceMappingURL=ContainerTreeList.js.map